import { TimeRange } from '@mi-front/core';
import { DateTime } from 'luxon';

export interface CalculateAllowedRangeOptions {
  /** Number of days to look back for the range start (start of that day). */
  retentionDays: number;
  /** Milliseconds to subtract from the reference time for the range end (e.g. live buffer lookback). */
  lookbackMs: number;
  /**
   * IANA timezone for the station (e.g. "America/Matamoros").
   * Start-of-day for `from` is computed in this zone, not the browser's.
   */
  timeZone: string;
}

/**
 * Computes the allowed [from, to] time window for the stream.
 *
 * - from: start of day (in {@link CalculateAllowedRangeOptions.timeZone}) for the date that is
 *   retentionDays before the reference time.
 * - to: reference time minus lookbackMs (e.g. to account for live delay or buffer).
 *
 * Any timestamp within [from, to] is considered valid for stream operations.
 */
export function calculateAllowedRange(
  nowMs: number,
  options: CalculateAllowedRangeOptions,
): TimeRange<number> {
  const { retentionDays, lookbackMs, timeZone } = options;
  const from = DateTime.fromMillis(nowMs, { zone: timeZone })
    .minus({ days: retentionDays })
    .startOf('day')
    .toMillis();
  const to = nowMs - lookbackMs;
  return { from, to };
}
